import React, { useCallback, useEffect, useRef,useMemo, useState } from 'react';
import AlarmModal, { OnAlarmClick, AlarmType } from '@/components/AlarmModal';
import { useRequest, useInterval } from 'ahooks';
import { GetParkRank,GetRoadRank, GetJoinParkIncomeRank,GetJoinParkIncomeRankV2,GetDataAccessQuality} from '@/services/api'
import Panel from '@/components/Panel/index'
import TopTale from '@/components/topTable';
import ImgSource from '@/assets/img/resource/zhouzhuan2.png'
import Abutton from '@/components/Abutton'
import { Spin } from 'antd'
import style from './style.module.scss'
import CustomTable from '@/components/CustomTable';

/** 停车场跳转地址 */

export interface ParkingTurnoverTableProps {
  areaCode?: string;
}
const $ = (selector: string) => document.querySelector(selector);
const ParkingTurnoverTable:React.FC<ParkingTurnoverTableProps> = props => {
  const [scrollInterval, setScrollInterval] = useState<number | null>(null);
  const [allowRefresh,setAllowRefresh] = useState(true);
  const [changModal,setChangModal] = useState(false);

const { data: roaddata=[],loading, error} = useRequest(useCallback(() => {
        // return GetJoinParkIncomeRank(
        return GetDataAccessQuality(
          {
            areaCode:props.areaCode,
          }
        )
    }, [props.areaCode]), {
      
        formatResult: res => {
          if(res.data){
            // eslint-disable-next-line array-callback-return
            let data= res.data.filter((item:object,index:number)=>{
              if(index<15){
                item['key']=index
                 return item
               }
             })
             return data
            }
            return res.data
        },
        refreshDeps: [props.areaCode]
  })  
  



  const scrollContainer = useCallback(() => {
    const container = $('.parking-turnover-table2 .ant-table-body');
    if (container !== null) {
      const { clientHeight, scrollHeight, scrollTop } = container;
      let height = scrollTop + 1;
      const top = scrollHeight - clientHeight - height;
      if (top <= 0) {
        height = 0
      }

      if (scrollHeight <= clientHeight) {
        setScrollInterval(null)
      }
      
      container.scrollTo(0,height)
    }
  }, [])

  const stopTick = useCallback(() => {
    setAllowRefresh(false);
    setScrollInterval(null)
  }, [])
  
  const startTick = useCallback(() => {
   setAllowRefresh(true);
    setScrollInterval(100)
  }, [])

  useInterval(() => {
    scrollContainer()
  }, scrollInterval)

  useInterval(() => {
   // refresh();
  },allowRefresh ? 60000 : null)


  useEffect(() => {
    const container = $('.parking-turnover-table2 .ant-table-body')
    if (container) {
      const { clientHeight, scrollHeight } = container;
      const isOver = scrollHeight > clientHeight
      if (isOver&&roaddata.length>0) {
        setScrollInterval(100)
      }
    }
  }, [roaddata])



  if (loading) {
    return (
      <Panel title="数据接入质量"  >
        <div className="fetch_container" style={{ height: 240 }}>
          <Spin/>
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title="数据接入质量"   >
        <div className="fetch_container" style={{ height: 240 }}>
          请求错误
        </div>
      </Panel>
    )
  }


  return (
    <Panel
      // title="停车场/停车位收入排行榜2222"
      title='数据接入质量'
    
      // renderLeft={AbuttonBox}
    >
       {/* <div className={style.parkinglotmore}  onClick={()=>showAlarm(9)}> 更多</div> */}
      <div onMouseEnter={stopTick} onMouseLeave={startTick}>
        <TopTale
          className="parking-turnover-table2"
          dataSource={roaddata}
          style={{height: '196px'}}
          rowKey="key"
          columns={[
            {
              title: '排行',
              render:(text,record,index)=>`TOP${index+1}`,
              },
            // { title: '区域' , dataIndex: 'areaName'},
            { title: '停车场名称', dataIndex: 'parkName'},
            // { title: '有效周转率',  dataIndex: 'validTurnover' },
            // { title: '总周转率',  dataIndex: 'turnover' },
            { title: '在线情况', dataIndex: 'onlineStatus',
              render:(text,record,index)=>{
                return text==1?'在线':'异常'
              }
            },
            { title: '置信度', dataIndex: 'plateConfidence'},
          ]}
           scroll={{y: 156}}
        />
      </div>
    </Panel>
  )
}

export default ParkingTurnoverTable;